import { Method as apiMethod } from 'axios'

export const cityEndpoints = {
  searchAutocomplete: {
    method: 'get' as apiMethod,
    url: '/city/search_autocomplete'
  }
}
